import styled from 'styled-components';

const Container = styled.h2`
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.41;
    letter-spacing: normal;
    text-align: left;
    color: #707070;
    padding-top: 3rem;
`;

type Props = {
    category: ContestCategory;
    categoryVotes?: number;
};

export const CategoryTitle = ({ category, categoryVotes }: Props) => {
    const votesLeft = category.maxVotes - categoryVotes;
    const showVotesCounter = category.maxVotes > 1;
    return (
        <Container>
            {category.name}
            {showVotesCounter && (
                <small style={{ fontSize: 14, paddingLeft: 10 }}>
                    Pozostało głosów: {votesLeft}
                </small>
            )}
        </Container>
    );
};

export default CategoryTitle;
